import { jsxs as u, jsx as p } from "react/jsx-runtime";
import { useState as x } from "react";
import "styled-components";
import { useThemeInMode as g } from "../../../context/theme/hooks.js";
import { DISABLED_TEXT_OPACITY as f } from "../../../styles/colors/consts.js";
import y from "../../content/Icon/Icon.js";
import "../../../ActionButton-B77eJAd5.js";
import "../../layout/Stack/Stack.js";
import s from "../../layout/Box/Box.js";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import "../../../hooks/link/index.js";
import "@material/material-color-utilities";
import "react-select";
import "react-select/async";
import "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../Toggle/CustomCheckbox.js";
import "focus-trap-react";
import "../../content/Logo/consts.js";
function q(n) {
  const {
    id: a,
    name: m,
    error: l,
    dataTest: d = "FormInput",
    disabled: t,
    ...e
  } = n, o = g(), [r, c] = x(!1), i = e.type === "password", h = i ? r ? "text" : "password" : e.type;
  return /* @__PURE__ */ u(
    s,
    {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      position: "relative",
      children: [
        /* @__PURE__ */ p(
          s,
          {
            disabled: t,
            component: "input",
            id: a,
            name: m,
            ...e,
            dataTest: d,
            width: "100%",
            borderRadius: "small",
            borderStyle: "solid",
            borderWidth: "xxxsmall",
            opacity: t ? f : "1",
            backgroundColor: o.foreground,
            color: o["neutral-high-content"],
            borderColor: l ? o["error-high-content"] : o["neutral-high-content"],
            focusStyles: {
              borderColor: o["primary-high-content"],
              outline: "0"
            },
            placeholderStyles: {
              color: o["neutral-medium-content"]
            },
            paddingLeft: "xlarge",
            paddingY: "12",
            paddingRight: i ? "xxxlarge" : "xlarge",
            type: h
          }
        ),
        i && /* @__PURE__ */ p(
          s,
          {
            top: "50%",
            right: "10px",
            position: "absolute",
            transform: "translateY(-50%)",
            cursor: t ? void 0 : "pointer",
            onClick: () => !t && c(!r),
            children: /* @__PURE__ */ p(
              y,
              {
                size: "xlarge",
                tone: "neutral",
                iconName: r ? "eyeSlashed" : "eye",
                accessibilityLabel: r ? "show" : "hide"
              }
            )
          }
        )
      ]
    }
  );
}
export {
  q as default
};
